import { render, staticRenderFns } from "./ResubmitInternational.vue?vue&type=template&id=01206e0c"
import script from "./ResubmitInternational.vue?vue&type=script&lang=js"
export * from "./ResubmitInternational.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports